import * as React from 'react';
import type { ButtonHTMLAttributes } from 'react';

import { chakra } from '@chakra-ui/react';

import { navigationButtonRecipe } from './theme';

export interface NavigationButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'aria-label' | 'children'
> {
  'aria-label': string;
  children: React.ReactNode;
  size?: 'sm' | 'md';
}

const StyledNavigationButton = chakra('button', navigationButtonRecipe);

export function NavigationButton({
  children,
  size = 'md',
  disabled,
  type = 'button',
  ...rest
}: NavigationButtonProps) {
  return (
    <StyledNavigationButton type={type} size={size} disabled={disabled} {...rest}>
      {children}
    </StyledNavigationButton>
  );
}
